import { render, staticRenderFns } from "./proxy-residential.vue?vue&type=template&id=b6340332&"
import script from "./proxy-residential.vue?vue&type=script&lang=js&"
export * from "./proxy-residential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports